:host {
   display: inline-block;
}

:host([fullwidth]) {
   display: block;
   width: 100%;
}

::slotted(*) {
   display: flex;
   align-items: center;
   justify-content: center;
}

.xx-large {
   font-size: 1.5rem;
}
